import React, { FC } from 'react'
import Skeleton, { SkeletonProps } from 'react-loading-skeleton'
import cn from 'classnames'

const SkeletonLoader: FC<SkeletonProps> = ({ className, ...rest }) => {
	return (
		// <div className={classNameDiv}>
			<Skeleton
				{...rest}
				baseColor='#f3f3f3'
				highlightColor='#ecebeb'
				className={cn('rounded-lg', className)}
			/>
		// </div>
	)
}

export default SkeletonLoader
